import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ImageGalleryComponent } from '../../../../shared/image-gallery/image-gallery.component';
import { NewsService } from '../../../../../services/news.service'
import { NewsItemResource } from 'src/app/interfaces/news-item-resource';
import { OverlayService } from 'src/app/services/overlay.service';
import { Router } from '@angular/router';
import {
  DecoupledEditor,
  AccessibilityHelp,
  Alignment,
  AutoLink,
  Autosave,
  BalloonToolbar,
  BlockQuote,
  Bold,
  Essentials,
  FontBackgroundColor,
  FontColor,
  FontFamily,
  FontSize,
  GeneralHtmlSupport,
  Heading,
  Highlight,
  HorizontalLine,
  Indent,
  IndentBlock,
  Italic,
  Link,
  List,
  Paragraph,
  RemoveFormat,
  SelectAll,
  SpecialCharacters,
  Strikethrough,
  Underline,
  Undo,
  type EditorConfig,
  ClassicEditor
} from 'ckeditor5';

import translations from 'ckeditor5/translations/de.js';

@Component({
  selector: 'app-add-appointment',
  templateUrl: './add-appointment.component.html',
  styleUrls: ['./add-appointment.component.scss']
})
export class AddAppointmentComponent implements OnInit {
  /**
   * addForm 
   */
  addForm: UntypedFormGroup;
  /**
   * dataForm
   */
  dataForm: UntypedFormGroup;
  /**
   * detailsForm
   */
  detailsForm: UntypedFormGroup;
  /**
   * descriptionForm
   */
  descriptionForm: UntypedFormGroup;
  /**
   * Will a new Image be uploaded
   */
  uploadImage: boolean = false;
  /**
   * ImageFormat
   */

  imageProperties = [
    { key: 'logo', value: null, hint: 'Format: 800 x 500, Typ: .png', hasChanged: false },
  ];
  /**
   * The Type of News
   */
  newsType = [
    { value: "APPOINTMENT", viewValue: "Veranstalltung" },
  ]
  /**
   * The State of News
   */
  states = [
    { value: "NEW", viewValue: "Neu" },
    { value: "DRAFT", viewValue: "Entwurf" },
    { value: "PUBLISHED", viewValue: "Veröffentlicht" },
    { value: "ARCHIVED", viewValue: "Archiviert" },
  ]
  /**
   * The Visibility of News
   */
  visibilityType = [
    { value: "PUBLIC", viewValue: "Alle" },
    { value: "PRIVATE", viewValue: "Kunden" },
  ]
  public Editor = ClassicEditor;
  public config = {
    toolbar: {
      items: [
        'undo',
        'redo',
        '|',
        'heading',
        '|',
        'bold',
        'italic',
        'underline',
        'strikethrough',
        '|',
        'link',
        'alignment',
        '|',
        'bulletedList',
        'numberedList',
        'outdent',
        'indent'
      ],
      shouldNotGroupWhenFull: true
    },
    plugins: [
      AccessibilityHelp,
      Alignment,
      AutoLink,
      Autosave,
      BalloonToolbar,
      BlockQuote,
      Bold,
      Essentials,
      FontBackgroundColor,
      FontColor,
      FontFamily,
      FontSize,
      GeneralHtmlSupport,
      Heading,
      Highlight,
      HorizontalLine,
      Indent,
      IndentBlock,
      Italic,
      Link,
      Paragraph,
      RemoveFormat,
      SelectAll,
      SpecialCharacters,
      Strikethrough,
      Underline,
      Undo,
      List
    ],
    heading: {
      options: [
        {
          model: 'paragraph',
          title: 'Paragraph',
          class: 'ck-heading_paragraph'
        },
        {
          model: 'heading1',
          view: 'h1',
          title: 'Überschrift 1',
          class: 'ck-heading_heading1'
        },
        {
          model: 'heading2',
          view: 'h2',
          title: 'Überschrift 2',
          class: 'ck-heading_heading2'
        },
        {
          model: 'heading3',
          view: 'h3',
          title: 'Überschrift 3',
          class: 'ck-heading_heading3'
        },
        {
          model: 'heading4',
          view: 'h4',
          title: 'Überschrift 4',
          class: 'ck-heading_heading4'
        },        {
          model: 'heading5',
          view: 'h5',
          title: 'Überschrift 5',
          class: 'ck-heading_heading5'
        }, 
        {
          model: 'heading6',
          view: 'h6',
          title: 'Überschrift 6',
          class: 'ck-heading_heading6'
        },  
      ]
    },
    htmlSupport: {
      allow: [
        {
          name: /^.*$/,
          styles: true,
          attributes: true,
          classes: true
        }
      ]
    },
    language: 'de',
    link: {
      addTargetToExternalLinks: true,
      defaultProtocol: 'https://',
      decorators: {
        toggleDownloadable: {
          mode: 'manual',
          label: 'Downloadable',
          attributes: {
            download: 'file'
          }
        }
      }
    },
    placeholder: '',
    translations: [translations]
  }

  /**
   * constructor
   * Init the Forms
   * @param fb 
   * @param dialog 
   * @param newsService 
   * @param overlayService 
   * @param router 
   */
  constructor(
    private fb: UntypedFormBuilder,
    private dialog: MatDialog,
    private newsService: NewsService,
    private overlayService: OverlayService,
    private router: Router
  ) {
    this.dataForm = this.fb.group({
      image: [null, []],
      title: ['', [Validators.required]],
      type: ['APPOINTMENT', [Validators.required]],
      state: ['', [Validators.required]],
      visibility: ['', [Validators.required]],

    })

    this.detailsForm = this.fb.group({
      publishedDate: ['', [Validators.required]],
      street: ['', []],
      city: ['', []],
      postcode: ['', []],
      fromDate: ['', [Validators.required]],
      untilDate: ['', [Validators.required]]
    })

    this.descriptionForm = this.fb.group({
      description: ['', []],
      content: ['', []]
    })
  }
  /**
   * ngOnInit
   */
  ngOnInit(): void {
  }
  /**
   * Create a new NewsItem
   * @returns 
   */
  createNewsItem() {
    this.dataForm.markAllAsTouched();
    this.detailsForm.markAllAsTouched();
    this.descriptionForm.markAllAsTouched();
    if (this.dataForm.invalid || this.detailsForm.invalid || this.descriptionForm.invalid) {
      return;
    }
    let t = {
      image: this.dataForm.value.image,
      title: this.dataForm.value.title,
      state: this.dataForm.value.state,
      type: this.dataForm.value.type,
      visibility: this.dataForm.value.visibility,
      description: this.descriptionForm.value.description,
      address: {
        street: this.detailsForm.value.street,
        city: this.detailsForm.value.city,
        postcode: this.detailsForm.value.postcode,
      },
      content: '',
      fromDate: Math.floor(new Date(this.detailsForm.getRawValue().fromDate).getTime()),
      untilDate: Math.floor(new Date(this.detailsForm.getRawValue().untilDate).getTime()),
      publishedDate: new Date(this.detailsForm.value.publishedDate).toISOString() ,
    }
    this.newsService.createNews(t).subscribe(val => {
      console.log(val)
      this.overlayService.openSnackBar("Veranstaltung erfolgreich angelegt!");
      this.router.navigate(['/caseworker/appointment'], {
        queryParams: {
          filterByStates: "NEW,DRAFT,PUBLISHED,ARCHIVED",
          filterByTypes: "APPOINTMENT",
          filterByVisibility: "PUBLIC,PRIVATE"
        }
      })
    })
  }
  /**
   * Open the Gallery to let the user select an Image 
   * @param property 
   */
  openImageGallery(property) {
    const dialogRef = this.dialog.open(ImageGalleryComponent);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.dataForm.patchValue({
          image: {
            deprecation: null,
            href: result?.url,
            hreflang: null,
            media: null,
            rel: "image",
            title: result?.title,
            type: result?.type,
          }
        })
        property.value = result.url;
        property.hasChanged = true;
        property.newValue = `${result.clientRef}/attachment/${result.publicId}`;
        this.uploadImage = true;
      }
    });
  }
  private formatDate(date) {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [year, month, day].join('-');
  }

  formatDateTime(date) {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    let hours = '' + Number(d.getHours());
    let minutes = '' + d.getMinutes();
    let seconds = '' + d.getSeconds();
    const year = d.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    if (hours.length < 2) hours = '0' + hours;
    if (minutes.length < 2) minutes = '0' + minutes;
    if (seconds.length < 2) seconds = '0' + seconds;
    return [year, month, day,].join('-') + "T" + [hours, minutes, seconds,].join(':');
  }
}
